<template>
  <div id="company">
    <div>
      <el-select v-model="queryBycompanyStatus" placeholder="请选择" @change="handleChangeCompanyStatus">
        <el-option
          v-for="n in companyStatus"
          :key="n.key"
          :label="n.label"
          :value="n.value">
        </el-option>
      </el-select>
      <el-select v-model="queryBycompanyType" placeholder="请选择" @change="handleChangeCompanyType" clearable>
        <el-option
          v-for="n in companyType"
          :key="n.key"
          :label="n.type"
          :value="n.id">
        </el-option>
      </el-select>
    </div>
    <div class="comond_btn">
      <el-button  @click="handleEdit(0, null)" >添加公司</el-button>
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          label="公司中文名"
          width="">
           <template slot-scope="scope">
             <div>{{ scope.row.chineseName }}</div>
           </template>
        </el-table-column>
        <el-table-column
          label="公司英文名"
          width="">
           <template slot-scope="scope">
             <div>{{ scope.row.englishName }}</div>
           </template>
        </el-table-column>
        <el-table-column
          prop="typeName"
          label="公司类型"
          width="">
        </el-table-column>
         <el-table-column
          prop="brand"
          label="品牌"
          width="">
        </el-table-column>
        <el-table-column
          prop="name"
          label="联系人"
          width="">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          width="">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱"
          width="">
        </el-table-column>
        <el-table-column
          prop="starLevel"
          label="公司星级"
          width="">
        </el-table-column>
        <!-- <el-table-column
          label="创建时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.createTime) }}</div>
           </template>
        </el-table-column> -->
        <el-table-column
          width="240"
          label="操作选项">
           <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handlequery(scope.row)">查看详情</el-button>
            <el-button
              size="mini"
              @click="handleEdit(1, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              v-if="scope.row.status === 1"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>

            <el-button
              size="mini"
              type="success"
              v-if="scope.row.status === 2"
              @click="handleDelete(scope.$index, scope.row)">还原</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="70%"
        center>
        <el-form :model="form" :rules="rules">
          
          <el-form-item label="公司中文名" :label-width="formLabelWidth">
            <el-input v-model="form.chineseName"></el-input>
          </el-form-item>

           <el-form-item label="公司英文名" :label-width="formLabelWidth">
            <el-input v-model="form.englishName"></el-input>
          </el-form-item>

          <el-form-item label="公司类型" :label-width="formLabelWidth" prop="typeId">
            <el-select v-model="form.typeId" placeholder="请选择" @change="handleChangeCompanyTypefromEdit" >
              <el-option
                v-for="n in companyType"
                :key="n.key"
                :label="n.type"
                :value="n.id">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="收货人地址(省市区)" :label-width="formLabelWidth">
            <el-cascader
              :options="options"
              v-model="selectedOptions"
              filterable
              clearable
              :props="props"
              @change="handleAreaChange">
            </el-cascader>
          </el-form-item>

          <el-form-item label="详细地址" label-width="120">
            <el-input placeholder="请输入详细街区道门牌号" v-model="orderUserDeliveryShow.address" clearable></el-input>
          </el-form-item> -->
          <p v-for="(n, index) in form.addresses" :key="n.key" class="addcontact" v-show="n.status === 1">

              <el-form-item label="地址" :label-width="formLabelWidth" required>
                <el-select v-model="form.addresses[index].typeId" placeholder="请选择地址类型">
                  <el-option
                    v-for="n in addressTypeList"
                    :key="n.key"
                    :label="n.type"
                    :value="n.id">
                  </el-option>
                </el-select>

                <el-select v-model="form.addresses[index].provinceCode" placeholder="请选择省(直辖市)" @change="(val) => { return handlechangeprovinceCode(index, val) }">
                  <el-option
                    v-for="n in provinceCodeList"
                    :key="n.key"
                    :label="n.areaName"
                    :value="n.id">
                  </el-option>
                </el-select>

                <el-select v-model="form.addresses[index].cityCode" placeholder="请选择市">
                  <el-option
                    v-for="n in cityCodeList"
                    :key="n.key"
                    :label="n.areaName"
                    :value="n.id">
                  </el-option>
                </el-select>
                
                <el-input v-model="form.addresses[index].address" placeholder="请输入详细街道地址"></el-input>

              </el-form-item>

              <el-button @click.prevent="removeDombyaddress(n)" type="danger">删除</el-button>
          </p>
          
          <el-form-item style="text-align:right;">
            <el-button @click="addDombyaddress()">新增参数</el-button>
          </el-form-item>

          <el-form-item label="统一社会信用代码" :label-width="formLabelWidth" prop="creditCodeCertificate">
            <el-input v-model="form.creditCodeCertificate"></el-input>
          </el-form-item>

          <el-form-item label="营业执照" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'businessLicence') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'businessLicence') }"
            >
              <img v-if="form.businessLicence" :src="form.businessLicence" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

           <el-form-item label="开户许可证" :label-width="formLabelWidth">
            <!-- 
              ##  token
              ##  必选参数上传地址
              ##  是否显示已上传文件列表
              ##  是否支持多选文件
              ##  上传之前
              ##  上传成功
            -->
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'openingLicense') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'openingLicense') }"
            >
              <img v-if="form.openingLicense" :src="form.openingLicense" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="公司开户行" :label-width="formLabelWidth">
            <el-input v-model="form.openingBank"></el-input>
          </el-form-item>

          <el-form-item label="银行账号" :label-width="formLabelWidth">
            <el-input v-model="form.bankAccount"></el-input>
          </el-form-item>

          <el-form-item label="公司传真" :label-width="formLabelWidth">
            <el-input v-model="form.fax"></el-input>
          </el-form-item>
          
          

          <el-form-item label="品牌" :label-width="formLabelWidth" v-if="form.typeId === 2" >
            <el-input v-model="form.brand"></el-input>
          </el-form-item>

          <el-form-item label="公司星级" :label-width="formLabelWidth">
             <el-rate
              v-model="form.starLevel"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']">
            </el-rate>
          </el-form-item>

          <el-form-item label="公司网址" :label-width="formLabelWidth">
            <el-input v-model="form.indexPage"></el-input>
          </el-form-item>

          <p v-for="(n, index) in form.contacts" :key="n.key" class="addcontact" v-show="n.status === 1">

            <el-form-item
              :label="'联系人' + parseInt(index+1)"
              :label-width="formLabelWidth"
              :prop="'contacts.' + index + '.name'"
              :rules=" { type: 'string', required: true, message: '请输入', trigger: 'blur' }"
            >
              <el-input v-model="n.name" placeholder="联系人" ></el-input>
            </el-form-item>

            <el-form-item
              :label="'手机'"
              :label-width="formLabelWidth"
              :prop="'contacts.' + index + '.phone'"
              :rules=" [{ type: 'string', required: true, message: '请输入', trigger: 'blur' }, { min: 11, max: 11, message: '长度在11位', trigger: 'blur' }]"
            >
              <el-input v-model="n.phone" placeholder="联系人" ></el-input>
            </el-form-item>

            <el-form-item
              :label="'职位'"
              :label-width="formLabelWidth"
              :prop="'contacts.' + index + '.positionId'"
              :rules=" { type: 'string', required: true, message: '请输入', trigger: 'blur' }"
            >
              <el-select v-model="form.contacts[index].positionId" filterable clearable placeholder="请选择">
                <el-option
                  v-for="item in positionList"
                  :key="item.key"
                  :label="item.position"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              :label="'邮箱'"
              :label-width="formLabelWidth"
              :prop="'contacts.' + index + '.email'"
            >
              <el-input v-model="n.email" placeholder="邮箱" ></el-input>
            </el-form-item>

            <el-form-item
              :label="'微信'"
              :label-width="formLabelWidth"
              :prop="'contacts.' + index + '.weChat'"
            >
              <el-input v-model="n.weChat" placeholder="微信" ></el-input>
            </el-form-item>

            <el-form-item
              :label="'qq'"
              :label-width="formLabelWidth"
              :prop="'contacts.' + index + '.qq'"
            >
              <el-input v-model="n.qq" placeholder="qq" ></el-input>
            </el-form-item>

            <el-form-item
              :label="'是否主要联系人'"
              :label-width="formLabelWidth"
              :prop="'contacts.' + index + '.isMajor'"
            >
            <el-col :span="12">
              <el-select v-model="form.contacts[index].isMajor" filterable clearable placeholder="请选择">
                <el-option
                  v-for="item in isMajor"
                  :key="item.key"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>

            <el-col :span="6">
              <el-button @click.prevent="removeDom(n)" type="danger">删除</el-button>
            </el-col>
            </el-form-item>
          </p>
          <el-form-item style="text-align:right;">
            <el-button @click="addDom()">新增参数</el-button>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handlesuccess(sts)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { findAll, companytypefindAll, companyadd, companydelete, qiniuupload, companyquery, companyupdate, areagetByParentId, positionfindAll, addressTypefindAll } from '../../api'
import utils from '../../../public/utils'
import moment from 'moment'
export default {
  data () {
    return {
      list: [],
      companyStatus: [ //  公司状态列表
        {
          value: null,
          label: '所有'
        },
        {
          value: 1,
          label: '有效公司'
        },
        {
          value: 2,
          label: '无效公司'
        }
      ],
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      isMajor: [
        {
          label: '是',
          value: 'Y'
        },
        {
          label: '否',
          value: 'N'
        },
      ],
      addressTypeList: [], //  地址分类列表
      provinceCodeList: [], //  省
      cityCodeList: [], //  市
      uploadUrl: '', //  上传地址前缀
      queryBycompanyStatus: 1, //  公司状态默认有效
      companyType: [], //  公司类型列表
      queryBycompanyType: null, //  公司类型默认有效
      centerDialogVisible: false, //  弹窗对话框默认关闭
      positionList: [],
      form: { //  新增初始化form
        // chineseName: 'chineseNames', //  中文名
        // englishName: 'chineseNames', //  英文名
        // creditCodeCertificate: 'chineseNames', //  代码许可证
        businessLicence: '',
        openingLicense: '', //  开户许可证
        // openingBank: 'chineseNames', //  开户行
        // bankAccount: '', //  银行账号
        // indexPage: '', //  公司网页
        // starLevel: '', //  公司星级
        // fax: '', //  传真
        // typeId: '', //  公司类型ID
        // brand: '', //  品牌
        contacts: [
          {
            name: '',
            phone: '',
            weChat: '',
            email: '',
            positionId: '',
            isMajor: '',
             status: 1,
          }
        ],
        typeId: '',
        addresses: [
          {
            address: '',
            typeId: '',
            provinceCode: '',
            cityCode: '',
            status: 1
          }
        ]
      },
      // companyTypefromEdit: null,
      formLabelWidth: '140px', //  表单文字宽度
      sts: 0, //  0 添加, 1 编辑
      title: '', //  添加窗口标题
      rules: {
        // typeId: [
        //   { required: true, message: '请选择公司类型', trigger: 'change' },
        // ],
        creditCodeCertificate: [
          { required: true, message: '请输入统一信用代码', trigger: 'blur' },
          { min: 18, max: 18, message: '长度在18位', trigger: 'blur' }
        ],
      },
      selectedOptions: [],
      options: [],
      props: {
        value: 'disCode',
        label: 'disName',
        children: 'district'
      },
    }
  },
  mounted () {
    this.getcompanytypefindAll() //  初始化查询所有公司类型
    this.getfindAll(this.queryBycompanyStatus, this.queryBycompanyType) //  默认查询条件为公司状态有效且公司类型为采购商的公司
    this.getToken()
    
  },
  methods: {
     getToken () { //  七牛
      let para = new URLSearchParams()
      para.append('bucket', 'crm-business-license')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.uploadUrl = res.data.url
      })
    },
    getaddressTypefindAll () { //  查询地址分类列表
      let para = {
        status: 1
      }
      addressTypefindAll(para).then(data => {
        console.log(data)
        this.addressTypeList = data.data.data
      })
    },
    getareagetByParentId (p) { //  层级区域查询
      let para = {}
      para.status = 1
      if (p) {
        para.parentId = p
        areagetByParentId(para).then(data => { //  查询市级
          console.log(data)
          this.cityCodeList = data.data.data
        })
      } else {
        areagetByParentId(para).then(data => { //  查询省级
          console.log(data)
          this.provinceCodeList = data.data.data
        })
      }
    },
    handlechangeprovinceCode (index, val) {
      console.log(index, val)
      this.form.addresses[index].cityCode = ''
      this.getareagetByParentId(val)
    },
    handlequery (row) { //  查看公司详情
      let para = {
        id: row.id
      }
      companyquery(para).then( data => {
        console.log(data.data.data)
        this.$router.push({ path: 'companydetail', query: { name: data.data.data }})
      })
    },
    getpositionfindAll () { //  查询所有职位
      let para = {
        'status': 1
      }
      positionfindAll(para).then(data => {
        console.log(data)
        this.positionList = data.data.data
      })
    },
    handleEdit (ind, row) { //  编辑或者新增
      this.centerDialogVisible = true
      this.getpositionfindAll()
      this.getaddressTypefindAll()
      this.getareagetByParentId()
      console.log(ind, row)
      if (ind === 1) {
        this.title = '修改公司信息'
        // this.form = row
        this.sts = 1
        let para = {
          id: row.id
        }
        companyquery(para).then( data => {
          console.log("表单数据:",data.data.data)
          this.form = data.data.data
          for (let i = 0; i < this.form.addresses.length; i++) {
            this.getareagetByParentId(this.form.addresses[i].provinceCode)
          }
        })
        
      } else {
        this.title = '新增公司'
        this.form = {}
        this.form = {
          openingLicense: '',
          businessLicence: '',
          contacts: [
            {
              name: '',
              phone: '',
              weChat: '',
              email: '',
              positionId: '',
              isMajor: '',
               status: 1,
            }
          ],
          addresses: [
          {
            address: '',
            typeId: '',
            provinceCode: '',
            cityCode: '',
            status: 1,
          }
        ]
        }
        this.sts = 0
      }
    },
    handlesuccess (sts) { //  提交修改信息
      // this.form.addresses = JSON.stringify(this.form.addresses)
      // this.form.contacts = JSON.stringify(this.form.contacts)
      let para = new URLSearchParams()
      para.append('companyDetailsVo', JSON.stringify(this.form))
      // let para = new URLSearchParams()
      // para.append('test', '')
      // para.append('chineseName', this.form.chineseName)
      // para.append('englishName', this.form.englishName)
      // para.append('creditCodeCertificate', this.form.creditCodeCertificate)
      // para.append('openingLicense', this.form.openingLicense)
      // para.append('openingBank', this.form.openingBank)
      // para.append('bankAccount', this.form.bankAccount)
      // para.append('indexPage', this.form.indexPage)
      // para.append('starLevel', this.form.starLevel)
      // para.append('fax', this.form.fax)
      // para.append('typeId', this.form.typeId)
      if (this.form.typeId == 2) { //  类型为供应商方可添加品牌
        para.append('brand', this.form.brand)
      }
      if (sts === 0) {
        companyadd(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getfindAll(this.queryBycompanyStatus, this.queryBycompanyType) //  默认查询条件为公司状态有效且公司类型为采购商的公司
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else {
        //  修改角色信息
        para.append('id', this.form.id)
        companyupdate(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getfindAll(this.queryBycompanyStatus, this.queryBycompanyType) //  默认查询条件为公司状态有效且公司类型为采购商的公司
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    handleDelete (ind, row) { //  删除方法
      console.log(ind, row)
      this.postcompanydelete(row.id)
    },
    postcompanydelete (s) { //  删除公司
     this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then( () => {
        let para = new URLSearchParams()
        para.append('id', s)
        companydelete(para).then( data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getfindAll(this.queryBycompanyStatus, this.queryBycompanyType) //  默认查询条件为公司状态有效且公司类型为采购商的公司
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      })
    },
    getfindAll (s, t) { //  查询全部公司
      let para = {
        status: s,
        typeId: t
      }
      findAll(para).then(data => {
        console.log(data)
        this.list = data.data.data
      })
    },
    getcompanytypefindAll (t) { //  查询公司类型列表
      let para = {
        typeId: t
      }
      companytypefindAll(para).then(data => {
        console.log(data)
        this.companyType = data.data.data
      })
    },
    handleChangeCompanyStatus (val) { //  根据公司状态查询公司
      this.queryBycompanyStatus = val
      this.getfindAll(this.queryBycompanyStatus, this.queryBycompanyType)
    },
    handleChangeCompanyType (val) { //  根据公司类型查询公司
      this.queryBycompanyType = val
      this.getfindAll(this.queryBycompanyStatus, this.queryBycompanyType)
    },
    handleChangeCompanyTypefromEdit (val) { //  修改状态下筛选公司类型
      console.log(val)
      this.form.typeId = val
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    handleBeforeUpload (file, obj) { //  上传之前
      this.qiniu.key = obj + `${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess (response, file, fileList, obj) { //  上传成功之后
      console.log(response, file, fileList, obj)
      this.form[obj] = this.uploadUrl + response.key
      console.log(this.form[obj])
      //  do some thing
    },
    /**
     * 多角色删除与添加
     */
    removeDom (item) { //  删除元素
      let dom = this.form.contacts
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        var index = dom.indexOf(item)
        // if (index !== -1) {
        //   dom.splice(index, 1)
        // }
       dom[index].status = 2
      }
    },
    addDom () { //  增加参数
      this.form.contacts.push(
        {
          name: '',
          phone: '',
          weChat: '',
          email: '',
          positionId: '',
          isMajor: '',
          status: 1,
        }
      )
    },
    removeDombyaddress (item) { //  删除元素
      console.log(item)
      console.log(1)
      let dom = this.form.addresses
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        // for (let i = 0; i< dom.length; i ++) {
        //   if (item.id === dom[i].id) {
        //     this.form.addresses[i].status = 2
        //   }
        // }
        var index = dom.indexOf(item)
        dom[index].status = 2
        console.log(this.form.addresses)

        // var index = dom.indexOf(item)
        // if (index !== -1) {
        //   dom.splice(index, 1)
        // }
      }
    },
    addDombyaddress () { //  增加参数
      this.form.addresses.push(
        {
          address: '',
          typeId: '',
          provinceCode: '',
          cityCode: '',
          status: 1
        }
      )
    },
  },
}
</script>
<style lang="stylus">
#company
  .addcontact
    border 1px solid #ccc
    padding 10px
    margin 10px 0
  .comond_btn
    display flex
    justify-content flex-end
    margin-bottom 30px
    button
      background-color #0a3d5f
      color #fff
  .el-rate
    line-height 2.5
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
